import { render, staticRenderFns } from "./MakeContribution.vue?vue&type=template&id=3558028d&scoped=true&"
import script from "./MakeContribution.vue?vue&type=script&lang=js&"
export * from "./MakeContribution.vue?vue&type=script&lang=js&"
import style0 from "./MakeContribution.vue?vue&type=style&index=0&id=3558028d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3558028d",
  null
  
)

export default component.exports